/**
 * Remove acentos de uma string para busca case-insensitive e accent-insensitive.
 * Ex: "João" → "joao", "Terça" → "terca"
 */
export const normalizeSearch = (str) => {
  if (!str) return '';
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

/**
 * Verifica se o texto contém o termo de busca, ignorando acentos e maiúsculas.
 */
export const matchesSearch = (text, searchTerm) => {
  if (!searchTerm) return true;
  if (!text) return false;
  return normalizeSearch(text).includes(normalizeSearch(searchTerm));
};
